module.exports = __webpack_public_path__ + "static/img/inco_logo.d122840e.svg";